/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import {
  ExtractionTopic,
  ExtractionTopicFromJSON,
  ExtractionTopicFromJSONTyped,
  ExtractionTopicToJSON,
} from "./ExtractionTopic";

/**
 *
 * @export
 * @interface ExtractionTopicFetchResponse
 */
export interface ExtractionTopicFetchResponse {
  /**
   *
   * @type {ExtractionTopic}
   * @memberof ExtractionTopicFetchResponse
   */
  data: ExtractionTopic;
}

export function ExtractionTopicFetchResponseFromJSON(
  json: any
): ExtractionTopicFetchResponse {
  return ExtractionTopicFetchResponseFromJSONTyped(json, false);
}

export function ExtractionTopicFetchResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): ExtractionTopicFetchResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: ExtractionTopicFromJSON(json["data"]),
  };
}

export function ExtractionTopicFetchResponseToJSON(
  value?: ExtractionTopicFetchResponse | null
): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: ExtractionTopicToJSON(value.data),
  };
}
